import {useEffect, useRef} from 'react';
import {getCssVariables} from '@ValidSignBV/theme-switcher';
import type {HostAppVariables, ThemeName} from '@ValidSignBV/theme-switcher';

interface UseScopedThemeParams {
    theme: ThemeName;
    hostAppVariables?: HostAppVariables;
}

export const useScopedTheme = ({theme, hostAppVariables}: UseScopedThemeParams): React.RefObject<HTMLDivElement> => {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!containerRef.current) return;

        const cssVariables = getCssVariables({theme, hostAppVariables});

        cssVariables.forEach((variable) => {
            containerRef.current?.style.setProperty(variable.name, variable.value);
        });

        return () => {
            if (containerRef.current) {
                cssVariables.forEach((variable) => {
                    containerRef.current?.style.removeProperty(variable.name);
                });
            }
        };
    }, [theme, hostAppVariables]);

    return containerRef;
};
